import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import GoogleMerchantIA from "@/pages/servicios/GoogleMerchantIA";


export const Route = createFileRoute("/servicios/google-merchant-ia")({
  head: () => ({
    meta: [
      { title: "Google Merchant Center con IA | Google Shopping Inteligente | SEOEVOLUTION" },
      { name: "description", content: "Si tus productos no aparecen en Google Shopping, los de tu competencia sí. IA que optimiza feeds, títulos y pujas. +150% conversiones, -40% CPC. Diagnóstico personalizado." },
      { name: "keywords", content: "Google Merchant Center, Google Shopping, feeds productos, optimización IA, campañas shopping, ecommerce, inteligencia artificial" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/google-merchant-ia" },
      { property: "og:title", content: "Google Merchant Center con IA | Google Shopping Inteligente | SEOEVOLUTION" },
      { property: "og:description", content: "IA que optimiza feeds, títulos y pujas en Google Shopping. +150% conversiones, -40% CPC." },
      { name: "twitter:title", content: "Google Merchant Center con IA | Google Shopping Inteligente | SEOEVOLUTION" },
      { name: "twitter:description", content: "IA que optimiza feeds, títulos y pujas en Google Shopping. +150% conversiones, -40% CPC." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/google-merchant-ia" }],
    scripts: serviceSchemaScripts("google-merchant-ia"),
  }),
  component: GoogleMerchantIA,
});
